import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {FormGroup, FormControl} from '@angular/forms';
import {environment} from 'src/environments/environment';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DialogService} from 'src/app/services/dialog.service';
import {map, filter, tap} from 'rxjs/operators';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  reCaptchaKey = environment.reCaptchaKey;
  captchaFormGroup = null;
  validForm = false;
  email: string = null;
  password = null;
  confirmPassword = null;
  validCaptcha = null;
  isValidEmail = null;
  isValidPhone = null;
  isValidLastName = null;
  isValidFirstName = null;
  firstName = '';
  lastName = '';
  phoneNumber = null;
  orgName = '';
  reCaptchaResponse = '';
  signupSuccess = false;
  signupInProgress = false;
  accountExistError = false;
  termsAccepted = false;

  emailRegexp = new RegExp(/^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i);
  phoneNumberRegexp = new RegExp(/^\+(?:[0-9] ?){6,14}[0-9]$/);

  constructor(
    private router: Router,
    private trustiiService: TrustiiService,
    private dialogService: DialogService,
    private route: ActivatedRoute
  ) {
    document.body.style.backgroundImage = 'url("/assets/img/TrustiiHomePage.png")';
    document.body.style.backgroundPosition = 'center center';
    document.body.style.backgroundRepeat = 'no-repeat';
    document.body.style.backgroundAttachment = 'fixed';
    document.body.style.backgroundSize = 'cover';
    this.captchaFormGroup = new FormGroup({
      captcha: new FormControl()
    });
  }

  ngOnInit() {}

  onEmailKey(e) {
    this.email = e.target.value;
    this.accountExistError = false;

    if (this.email.length === 0) {
      this.isValidEmail = null;
    } else if (this.emailRegexp.test(this.email)) {
      this.isValidEmail = true;
    } else {
      this.isValidEmail = false;
    }

    this.updateFormValidity();
  }

  onPasswordKey(e) {
    this.password = e.target.value;
    this.updateFormValidity();
  }

  onFirstName(e) {
    this.firstName = e.target.value;
    if (this.firstName.length === 0) {
      this.isValidFirstName = null;
    } else if (this.firstName.indexOf('.') > -1) {
      this.isValidFirstName = false;
    } else {
      this.isValidFirstName = true;
    }
    this.updateFormValidity();
  }

  onLastName(e) {
    this.lastName = e.target.value;
    if (this.lastName.length === 0) {
      this.isValidLastName = null;
    } else if (this.lastName.indexOf('.') > -1) {
      this.isValidLastName = false;
    } else {
      this.isValidLastName = true;
    }
    this.updateFormValidity();
  }

  onPhoneKey(e) {
    this.phoneNumber = e.target.value;
    if (this.phoneNumber.length === 0) {
      this.isValidPhone = null;
    } else if (this.phoneNumberRegexp.test(this.phoneNumber)) {
      this.isValidPhone = true;
    } else {
      this.isValidPhone = false;
    }
    this.updateFormValidity();
  }

  onOrgName(e) {
    this.orgName = e.target.value;
    this.updateFormValidity();
  }

  onCreateAccount(e) {
    if (!this.emailRegexp.test(this.email)) {
      this.dialogService.openAlertDialog(
        '350px',
        'Invalid email id',
        'ERROR',
        'Ok',
        'modal-warning'
      );
      return;
    }

    if (this.password !== this.confirmPassword) {
      this.dialogService.openAlertDialog(
        '350px',
        'Passwords do not match',
        'ERROR',
        'Ok',
        'modal-warning'
      );
      return;
    }

    this.signupInProgress = true;
    const payload = {
      email: this.email,
      firstname: this.firstName,
      lastname: this.lastName,
      phoneNumber: this.phoneNumber,
      enterprise: this.orgName,
      captchaKey: this.reCaptchaResponse,
    };
    this.trustiiService.signup(payload).subscribe(res => {
      this.signupSuccess = true;
      this.signupInProgress = false;
    }, err => {
      this.signupInProgress = false;
      this.captchaFormGroup.controls.captcha.reset();
      const jerr = JSON.parse(JSON.stringify(err.error.error));
      if (err && err.error && jerr.status === 400 && jerr.code === 'account_already_exist') {
        this.accountExistError = true;
        this.isValidEmail = false;
      } else {
        this.dialogService.openAlertDialog(
          '350px',
          'Failed to create account at this time. Please try again later.',
          'ERROR',
          'Ok',
          'modal-warning'
        );
      }
    });
  }

  openTermsInNewWindow() {
    window.open('/assets/pdf/TRUSTII-Conditions Générales de Prestation de Services.pdf');
  }

  openPolicyInNewWindow() {
    window.open('privacy');
  }

  goHome() {
    this.router.navigateByUrl('', {skipLocationChange: false});
  }

  redirectToSignIn() {
    this.router.navigateByUrl('');
  }

  resolved(captchaResponse: string) {
    if (captchaResponse === null || captchaResponse.length === 0) {
      this.validCaptcha = false;
      this.updateFormValidity();
      return;
    }
    this.reCaptchaResponse = captchaResponse;
    this.validCaptcha = true;
    this.updateFormValidity();
  }

  updateFormValidity() {
    if (this.emailRegexp.test(this.email) && this.validCaptcha &&
      !(this.firstName.indexOf('.') > -1) && !(this.lastName.indexOf('.') > -1) &&
      (this.phoneNumber && this.phoneNumber.length > 0 ? this.phoneNumberRegexp.test(this.phoneNumber) : true)) {
      this.validForm = true;
    } else {
      this.validForm = false;
    }
  }
}
